<template>
  <CRow>
    <CCol col="12">
      <CCard>
        <CCardHeader>
          <h4>Ρυθμίσεις Τύπων Παραστατικών</h4>
          <small>Επιλέξτε ποιοι τύποι παραστατικών θα εμφανίζονται στα dropdown ανά γλώσσα (Ελληνικά / English)</small>
        </CCardHeader>
        <CCardBody>
          <CModal
            class="modalAlert"
            :show.sync="alertIsShown"
            :centered="true"
            size="lg"
          >
            <CAlert
              closeButton
              :show.sync="alertIsShown"
              color="success"
              fade
            >
              {{ message }}
            </CAlert>
          </CModal>

          <div v-if="loading" class="text-center py-5">
            <CSpinner color="primary" />
            <p class="mt-3">Φόρτωση...</p>
          </div>

          <CDataTable
            v-else
            :items="documentSeries"
            :fields="fields"
            hover
            sorter
            column-filter
            table-filter
            items-per-page-select
            :items-per-page="15"
            pagination
          >
            <template #greek_name="{item}">
              <td>
                <strong>{{ item.greek_name }}</strong>
                <br>
                <small class="text-muted">{{ item.code }}</small>
              </td>
            </template>

            <template #english_name="{item}">
              <td>
                {{ item.english_name }}
              </td>
            </template>

            <template #lang="{item}">
              <td>
                <CBadge :color="item.lang === 'gr' ? 'info' : item.lang === 'en' ? 'warning' : 'secondary'">
                  {{ item.lang === 'gr' ? 'Ελληνικά' : item.lang === 'en' ? 'English' : 'Και τα δύο' }}
                </CBadge>
              </td>
            </template>

            <template #cancelled="{item}">
              <td>
                <CBadge :color="item.cancelled ? 'danger' : 'success'">
                  {{ item.cancelled ? 'Ακυρωτικό' : 'Ενεργό' }}
                </CBadge>
              </td>
            </template>

            <template #is_visible_gr="{item}">
              <td>
                <CSwitch
                  :checked="item.is_visible_gr"
                  color="success"
                  variant="opposite"
                  @update:checked="toggleVisibilityGr(item)"
                />
              </td>
            </template>

            <template #is_visible_en="{item}">
              <td>
                <CSwitch
                  :checked="item.is_visible_en"
                  color="success"
                  variant="opposite"
                  @update:checked="toggleVisibilityEn(item)"
                />
              </td>
            </template>
          </CDataTable>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import axios from 'axios';

export default {
  name: 'InvoiceTypeSettings',
  data() {
    return {
      documentSeries: [],
      loading: true,
      alertIsShown: false,
      message: '',
      fields: [
        { key: 'greek_name', label: 'Ελληνική Ονομασία', _style: 'width:20%;' },
        { key: 'english_name', label: 'English Name', _style: 'width:20%;' },
        { key: 'lang', label: 'Γλώσσα', _style: 'width:12%;' },
        { key: 'cancelled', label: 'Κατάσταση', _style: 'width:12%;' },
        { key: 'is_visible_gr', label: 'Εμφάνιση Ελληνικά', _style: 'width:18%;' },
        { key: 'is_visible_en', label: 'Εμφάνιση English', _style: 'width:18%;' }
      ]
    };
  },
  mounted() {
    this.loadDocumentSeries();
  },
  methods: {
    loadDocumentSeries() {
      this.loading = true;
      console.log('Loading document series...');
      axios
        .get('/api/settings/document-series?token=' + localStorage.getItem('api_token'))
        .then((response) => {
          console.log('API Response:', response);
          console.log('Document series data:', response.data);
          this.documentSeries = response.data.document_series;
          console.log('Loaded document series:', this.documentSeries);
          this.loading = false;
        })
        .catch((error) => {
          console.error('Error loading document series:', error);
          console.error('Error response:', error.response);
          this.loading = false;
          if (error.response && error.response.status === 401) {
            this.$router.push({ path: '/login' });
          }
        });
    },
    toggleVisibilityGr(item) {
      const newVisibility = !item.is_visible_gr;

      axios
        .put(
          `/api/settings/document-series/${item.id}/visibility?token=` + localStorage.getItem('api_token'),
          {
            is_visible_gr: newVisibility
          }
        )
        .then((response) => {
          item.is_visible_gr = newVisibility;
          this.message = `Η ορατότητα (Ελληνικά) του "${item.greek_name}" ενημερώθηκε επιτυχώς!`;
          this.showAlert();
        })
        .catch((error) => {
          console.error('Error updating visibility:', error);
          if (error.response && error.response.status === 401) {
            this.$router.push({ path: '/login' });
          }
        });
    },
    toggleVisibilityEn(item) {
      const newVisibility = !item.is_visible_en;

      axios
        .put(
          `/api/settings/document-series/${item.id}/visibility?token=` + localStorage.getItem('api_token'),
          {
            is_visible_en: newVisibility
          }
        )
        .then((response) => {
          item.is_visible_en = newVisibility;
          this.message = `Η ορατότητα (English) του "${item.greek_name}" ενημερώθηκε επιτυχώς!`;
          this.showAlert();
        })
        .catch((error) => {
          console.error('Error updating visibility:', error);
          if (error.response && error.response.status === 401) {
            this.$router.push({ path: '/login' });
          }
        });
    },
    showAlert() {
      this.alertIsShown = true;
    }
  }
};
</script>

<style scoped>
.text-center {
  text-align: center;
}
.py-5 {
  padding-top: 3rem;
  padding-bottom: 3rem;
}
.mt-3 {
  margin-top: 1rem;
}
</style>
